import { render } from "./MyFooter.vue?vue&type=template&id=58e9c1cd&scoped=true&ts=true"
import script from "./MyFooter.vue?vue&type=script&lang=ts"
export * from "./MyFooter.vue?vue&type=script&lang=ts"

import "./MyFooter.vue?vue&type=style&index=0&id=58e9c1cd&lang=less&scoped=true"

import exportComponent from "D:\\code\\hyz-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58e9c1cd"]])

export default __exports__